import React from 'react';
import core from '@gin-betting/core';
import cn from 'classnames';

import UserDevice from 'services/user-device';

import './input.scss';

const {
    utils: { getCurrency },
} = core;

interface Props {
    isDisabled?: boolean;
    value: string;
    onBlur: InputEl['onBlur'];
    onFocus: InputEl['onFocus'];
    onChange: InputEl['onChange'];
    isInputFocused: boolean;
    onKeyDown?: InputEl['onKeyDown'];
}

const Input: React.FC<Props> = ({
    isDisabled,
    onBlur,
    onFocus,
    value,
    onChange,
    isInputFocused,
    onKeyDown,
}) => {
    const isDesktop = !UserDevice.getInstance()?.isDeviceMobile();
    const inputMode = isDesktop ? ('text' as const) : ('decimal' as const);
    const { currencyName } = getCurrency();

    return (
        <div
            styleName={cn('wrapper', {
                'is-focused': isInputFocused,
                'is-disabled': isDisabled,
                'is-desktop': isDesktop,
            })}
        >
            <input
                styleName="input"
                disabled={isDisabled}
                inputMode={inputMode}
                min={0}
                onBlur={onBlur}
                onFocus={onFocus}
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
            />
            <div styleName="currency">{currencyName}</div>
        </div>
    );
};

export default Input;
